import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import { fetchChatMessages, fetchActiveChatSessions } from '../../../../../data/fetch';
import { useI18n } from '../../../../../data/hooks/i18nHooks';
import ButtonLink from '../../../../elements/ButtonLink';
import { dialogAlert } from '../../../../elements/Dialog/dialogs';
import Input from '../../../../elements/forms/Input';
import styles from './CreateChatMessage.module.scss';

function CreateChatMessage(props) {
    const { event, otherParticipant } = props,
        [message, setMessage] = useState(''),
        [sendingMessage, setSendingMessage] = useState(false),
        i18n = useI18n(),
        ref = useRef(),
        { chatSessionId } = useParams();

    const handleSubmit = useCallback((e) => {
        e.preventDefault();
        setSendingMessage(true);
    }, []);

    // send message
    useEffect(() => {
        if (sendingMessage) {
            let mounted = true;

            async function postMessage() {
                try {
                    const data = await app.api.chat.postMessage(message, otherParticipant.id, event?.id);
                    if (mounted) {
                        setMessage('');
                        if (!chatSessionId || chatSessionId != data.chatId) {
                            fetchActiveChatSessions.cache.clear();
                            if (event?.id) {
                                await fetchActiveChatSessions(event.id);
                            }
                            await fetchChatMessages(data.chatId);
                            app.history.replace(`../${data.chatId}`);
                        }
                    }
                } catch (err) {
                    if (err.response?.status == 429) {
                        switch (err.response.data.error) {
                            case 'too_many_unanswered_chats':
                                await dialogAlert(i18n['error.too_many_unanswered_chats'], i18n['label.error']);
                                break;
                        }
                    } else if (err.response?.data?.error == 'chat_contact_not_allowed') {
                        // server message is already translated
                        await dialogAlert(err.response.data.error_message, i18n['label.error']);
                    } else if (err.response?.status) {
                        await dialogAlert(i18n['message.networkerror'], i18n['label.error']);
                    } else {
                        console.log(err);
                    }
                } finally {
                    if (mounted) {
                        setSendingMessage(false);
                    }
                }
            }
            postMessage();

            return () => (mounted = false);
        } else {
            try {
                ref.current.querySelector('textarea').focus();
            } catch (error) {}
        }
    }, [sendingMessage]);

    if (!event) return null;
    if (!event.loaded) return null;

    return (
        <form ref={ref} className={['content', styles.CreateChatMessage].join(' ')} onSubmit={handleSubmit}>
            <textarea className="form-control" value={message} onChange={(e) => setMessage(e.target.value)} disabled={sendingMessage} placeholder={i18n['label.message']} />
            <ButtonLink type="submit" disabled={sendingMessage} title={i18n['label.send']} />
        </form>
    );
}

export default CreateChatMessage;
